var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef } from 'react';
// import {
//   ResourceCard,
//   PropTypes as ResourceCardTypes,
// } from '../resourceCard/ResourceCard';
import Carousel from './Micros/Carousel';
import './CardCarousel.scss';
import SwiperCore, { Virtual, Navigation } from 'swiper';
SwiperCore.use([Virtual, Navigation]);
import '../../lib/styles/swiper.scss';
import card0 from '../../assets/images/1_story_image.png';
import card1 from '../../assets/images/2_story_image.png';
// import card2 from '../../assets/images/3_Story_Image.png';
var defaultProps = {
    data: {
        title: 'Related Content',
        contentCardList: [
            {
                title: 'What Are Value Stocks? All You Need To Know',
                date: '11 OCT 2021',
                image: card0,
            },
            {
                title: 'Why Individual Stock Selection Is A Bad Approach To Investing',
                date: '11 OCT 2021',
                image: card1,
            },
            {
                title: 'Momentum Stocks: Does Popularity Result In Profitability?',
                date: '11 OCT 2021',
                image: card1,
            },
        ],
    },
};
export var ContentCardsChildComp = function (_a) {
    var className = _a.className, data = _a.data;
    // console.log(data, 'props');
    var customPolygon = "polygon(0 0%, 0 110%, 102% 100%)";
    var _b = useState(0), scrolledBy = _b[0], setScrolledBy = _b[1];
    var _c = useState(0), margin = _c[0], setMargin = _c[1];
    var navigationPrevRef = useRef(null);
    var navigationNextRef = useRef(null);
    var scrollHandler = function (e) {
        var target = e.target;
        var scrollLeft = target.scrollLeft, scrollWidth = target.scrollWidth, clientWidth = target.clientWidth;
        var width = scrollWidth - clientWidth;
        // console.log(scrollLeft, scrollWidth, clientWidth, 'width');
        setScrolledBy((scrollLeft / width) * 100);
    };
    var onBeforeInitHandler = function (swiper) {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
    };
    // useEffect(() => {
    //   const tl = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: '.card-carousel-anime',
    //       start: 'top center',
    //     },
    //   });
    //   tl.to('.card-carousel-anime', {
    //     autoAlpha: 1,
    //     duration: 1,
    //     stagger: {
    //       each: 0.5,
    //     },
    //   });
    // });
    return (_jsx("div", { children: _jsx("div", __assign({ className: "card-carousel-section relative w-full snap-center " }, { children: _jsx("div", __assign({ className: "card-carousel card-carousel-content-cards relative w-full  px-0 pb-8" }, { children: _jsx("div", __assign({ className: "card-carousel-anime text-white", onScroll: scrollHandler }, { children: _jsx(Carousel, { title: data.data.title, cardsArray: data.data.contentCardList }, void 0) }), void 0) }), void 0) }), void 0) }, void 0));
};
